<template>
  <router-view></router-view>
</template>

<script>
export default {
  name: "App",
};
</script>

<style src="@/assets/css/app-var.css"></style>
<style src="@/assets/css/app-style.css"></style>
<style src="@/assets/css/app-inputs-style.css"></style>
<style src="@/assets/css/app-btn-style.css"></style>
